<template>
<div class="canvas-area">
  <!-- ひらがなの書き順 -->
  <md-card md-with-hover v-for="items in hiraganaSrcList" v-bind:key="items.id">
    <md-ripple>
      <md-card-media>
        <img v-lazy="items.src" alt="" @click="hiraganaAudio()">
      </md-card-media>
    </md-ripple>
  </md-card>
  <!-- 書くフィールド -->
  <Draw ref="draw" :backgroundImage="backgroundImage" @toggleContentsVisible="toggleContentsVisible" />
  <!-- カタカナの書き順 -->
  <md-card md-with-hover v-for="items in katakanaSrcList" v-bind:key="items.id">
    <md-ripple>
      <md-card-media>
        <img v-lazy="items.src" alt="" @click="katakanaAudio()">
      </md-card-media>
    </md-ripple>
  </md-card>

</div>
</template>

<script>
import Draw from './Draw.vue'
export default {
  name: 'Canvas',
  props: {
    imageNo: {
      type: Number
    },
    backgroundImage: {
      type: String,
      default: ''
    }
  },
  components: {
    Draw
  },
  data: () => ({
    mode: '',
    brushColor: '',
    defaultMode: 'brush',
    defaultBrushColor: '#000000',
    hiraganaSrcList: [],
    katakanaSrcList: [],
    audioSrc: '',
    hiraganaAudioSrc: '',
    katakanaAudioSrc: ''
  }),
  created: function () {
    var strokeOrder = this.getStrokeOrder(this.imageNo)
    this.hiraganaSrcList = strokeOrder.hiraganaSrcList
    this.katakanaSrcList = strokeOrder.katakanaSrcList
    this.audioSrc = require('@/assets/wja/audio/writingjapaneseanimal_' + this.imageNo + '_audio.mp3')
    this.hiraganaAudioSrc = require('@/assets/wja/audio/hiragana.mp3')
    this.katakanaAudioSrc = require('@/assets/wja/audio/katakana.mp3')
  },
  mounted: function () {
    this.init()
  },
  methods: {
    // モードとペンの色を初期状態にする
    init: function () {
      this.mode = this.defaultMode
      this.brushColor = this.defaultBrushColor
    },
    // キャンバスをクリアする
    onClearCanvas: function () {
      this.$refs.draw.onClearCanvas()
      this.init()
    },
    toggleContentsVisible: function () {
      this.$emit('toggleContentsVisible')
    },
    hiraganaAudio: function () {
      this.playAudio(this.hiraganaAudioSrc)
      // TODO いっぺんにしゃべらないでほしい
      // this.playAudio()
    },
    katakanaAudio: function () {
      this.playAudio(this.katakanaAudioSrc)
      // TODO いっぺんにしゃべらないでほしい
      // this.playAudio(this.audioSrc)
    }
  }
}
</script>
<style lang="scss" scoped>
.md-card {
  width: 150px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/paint/Canvas.vue